import { Provider } from '@angular/core';
import { MODAL_REGISTRY } from '@features/modals/modal-registry.token';
import { TradeModalComponent } from '@features/modals/trade-modal/trade-modal.component';
import { IFrameModal } from '@features/modals/iframe-modal/iframe-modal.component';
import { OurDepositsModalComponent } from '@features/modals/our-deposits-modal/our-deposits-modal.component';

export function provideSharedModals(): Provider[] {
  return [
    { provide: MODAL_REGISTRY, useValue: { key: 'TradeModal', component: TradeModalComponent, requiresAuth: true }, multi: true },
    { provide: MODAL_REGISTRY, useValue: { key: 'IFrameModal', component: IFrameModal, requiresAuth: true }, multi: true },
    { provide: MODAL_REGISTRY, useValue: { key: 'OurDepositsModal', component: OurDepositsModalComponent }, multi: true },
  ];
}
